import { number, string } from "prop-types";

export const RegistrationTierDescription = {
  /** Identifier for the registration tier description. */
  id: number.isRequired,

  /** Text description to be shown with the registration tier. */
  description: string.isRequired,
};
